import React from 'react';
import PropTypes from 'prop-types';

/**
 * Field - A wrapper that renders a standard HTML div with Bulma class names
 *
 * This component accepts the same props as Bloomer Field for easy migration
 */
const Field = ({
  className = '',
  children = null,
  style = {},
  tag: Tag = 'div',
  isGrouped = false,
  hasAddons = false,
  isHorizontal = false,
  ...props
}) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = ['field'];

    // Add appropriate classes based on props
    if (isGrouped) {
      // Always add is-grouped class first
      classes.push('is-grouped');
      
      // Then add the specific positioning if provided
      if (typeof isGrouped === 'string') {
        classes.push(`is-grouped-${isGrouped}`);
      }
    }

    if (hasAddons) {
      classes.push('has-addons');
    }

    if (isHorizontal) {
      classes.push('is-horizontal');
    }

    // Add custom class names
    if (className) {
      classes.push(className);
    }

    return classes.join(' ');
  };

  return (
    <Tag className={getClassNames()} style={style} {...props}>
      {children}
    </Tag>
  );
};

// eslint-disable-next-line react/require-default-props
Field.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
  tag: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.object,
  ]),
  isGrouped: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  hasAddons: PropTypes.bool,
  isHorizontal: PropTypes.bool,
};



export default Field;
